import { render, staticRenderFns } from "./KeyboardShortcut.vue?vue&type=template&id=12c9f20c&scoped=true&"
import script from "./KeyboardShortcut.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcut.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardShortcut.vue?vue&type=style&index=0&id=12c9f20c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9f20c",
  null
  
)

export default component.exports